export interface IOption<T = number> {
  leasing_switch?: boolean;
  name: string;
  id: T;
  active?: boolean;
  disable_cause?: string;
  product_type?: number;
}
